<template>
  <component
    :is="to ? 'NuxtLink' : 'a'"
    :to="to"
    :href="!to ? '#' : undefined"
    :class="`${variant} ${
      disabled
        ? 'disabled text-gray-400 border-gray-400 cursor-not-allowed pointer-events-none'
        : 'border-black text-black'
    } bullet-content no-underline w-fit transition-all leading-none`"
    @click.prevent="handleClick"
  >
    <span class="flex items-center" v-html="content"></span>
  </component>
</template>

<script>
import { computed, defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'VaimoLink',
  props: {
    variant: {
      required: false,
      type: String,
      default: 'primary',
      validator: (value) =>
        ['primary', 'alternative', 'secondary'].includes(value)
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    },
    label: {
      required: true,
      type: String,
      default: 'Label'
    },
    price: {
      required: false,
      type: String,
      default: 'N/A'
    },
    to: {
      required: false,
      type: [String, Object, null],
      default: null
    },
    onClick: {
      required: false,
      type: Function,
      default: null
    }
  },
  emits: ['click'],
  setup(props, { emit }) {
    const content = computed(() => {
      switch (props.variant) {
        case 'alternative':
          return (
            `<span class="bullet-content__label flex items-center">${props.label}</span>` +
            `<span class="bullet-content__price">${props.price}</span>`
          );
        case 'primary':
        case 'secondary':
        default:
          return props.label;
      }
    });

    const handleClick = (event) => {
      if (props.disabled) {
        event.preventDefault();
        return;
      }

      if (!props.to) {
        if (props.onClick) {
          event.preventDefault();
          props.onClick(event);
        }
        emit('click', event);
      }
    };

    return {
      content,
      handleClick
    };
  }
});
</script>

<style lang="scss" scoped>
$bullet-content: '•';
$bullet-margin: 0.5rem;
$bullet-size: 0.5em;

.bullet-content {
  font-family: var(--font-family--secondary);
  font-size: var(--font-size--base);
  border-bottom: 1px solid black;
  padding-bottom: 4px;

  &:hover {
    padding-bottom: 3px;
    border-bottom-width: 2px;
  }

  &.primary {
    font-size: var(--font-size--xl);
  }

  &.primary::before,
  &.primary::after {
    content: '•';
    color: inherit;
    font-size: $bullet-size;
    display: inline-block;
  }
  &.primary::before {
    margin-right: $bullet-margin;
  }
  &.primary::after {
    margin-left: $bullet-margin;
  }

  &.secondary {
    font-size: var(--font-size--base);
  }

  &.alternative {
    font-size: var(--font-size--base);
    .bullet-content__label::after {
      content: $bullet-content;
      color: inherit;
      font-size: $bullet-size;
      display: inline-block;
      margin-right: $bullet-margin;
    }
  }
}
</style>
<style lang="scss">
$bullet-content: '•';
$bullet-size: 0.5em;

.bullet-content.alternative .bullet-content__label::after {
  content: $bullet-content;
  color: inherit;
  font-size: $bullet-size;
  display: inline-block;
  width: 1rem;
  text-align: center;
}
</style>
